import React, { useState, useEffect } from 'react'
import Loader from '../../../../../presentationals/Loader/Loader.component'
import { getaggregatorLinkDataByPageNo } from '../../../maketingComponents/actioncreator';
import Pagination from '@mui/material/Pagination';
const size = 10;
export default function Leads({ Data }) {
    const [currentPage, setcurrentPage] = useState(1)
    const [totalPage, setTotalPage] = useState(0)
    const [loader, setLoader] = useState(false)
    const [tableData, settableData] = useState([])

    useEffect(() => {
        ApiData(currentPage)
    }, [])

    const ApiData = (page) => {
        setLoader(true)
        getaggregatorLinkDataByPageNo(Data?.id ?? "", page, size, callback => {
            setLoader(false)
            settableData(callback?.data?.aggregatorLinkData ?? [])
            setTotalPage(callback?.data?.totalCount ?? 0)
        })
    }

    const handleChange = (event, value) => {
        setcurrentPage(value);
        ApiData(value)
    };

    return (
        <>
            {loader ? <Loader /> : ""}
            <div className='OverView-Main-Section min-size-marketing-1800'>
                <div className="row">
                    <div className="col-xs-12">
                        <div className="customDash-table" style={{ marginTop: '30px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h5>Leads's List</h5>

                            </div>
                            <div className='main-customized-table'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Email Id</th>
                                            <th>Mobile Number</th>
                                            <th>State</th>
                                            <th>Company Name</th>
                                            <th>Is Mobile Verified</th>
                                            <th>Form Status</th>
                                            <th>Login Date</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            tableData?.length > 0 ? tableData?.map((val, id) => {
                                                return (
                                                    <tr key={id}>

                                                        <td>{val?.firstName ?? ""}</td>
                                                        <td>{val?.emailId ?? ""}</td>
                                                        <td>{val?.mobileNumber ?? ""}</td>
                                                        <td>{val?.state ?? ""}</td>
                                                        <td>{val?.companyName ?? ""}</td>
                                                        <td>{val?.mobileVerified ?? ""}</td>
                                                        <td>{val?.formStatus ?? ""}</td>
                                                        <td>{val?.loginDate ?? ""}</td>
                                                    </tr>
                                                )
                                            })
                                                : ""}


                                    </tbody>
                                </table>
                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>

                                    <Pagination
                                        count={Math.ceil(totalPage / size)}
                                        page={currentPage}
                                        onChange={handleChange}
                                        color="primary"
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
